<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="类型"
        prop="type_id"
        :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
      >
        <el-select v-model="state.model.type_id" placeholder="选择会议厅">
          <el-option
            v-for="item in state.type_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadType"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item
        label="数量"
        prop="num"
        :rules="[{ required: true, message: '请输入数量', trigger: 'blur' }]"
      >
        <el-input-number
          v-model="state.model.num"
          precision="0"
          class="number-input-left !w-full"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="负责人"
        prop="belonger_id"
        :rules="[{ required: true, message: '请选择负责人', trigger: 'blur' }]"
      >
        <c_userselect
          v-model="state.model.belonger_id"
          @change:item="
            (item) => {
              state.model.belonger_department_id = item.department_id;
            }
          "
        />
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-model="state.model.intro" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_place_detail,
  meeting_place_add,
  meeting_place_edit,
} from "@/http/meeting";
import { data_getHotel, data_getHotelHall } from "@/http/data";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      state.model.meeting_id = props.meeting_id;
      onLoadType();
      if (props.id) {
        meeting_place_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data;
          }
        });
      }
    });

    //获取物料类型
    const onLoadType = () => {
      data_getHotelHall(state.model.hotel_id).then((res) => {
        if (res.status == 200) state.hall_data = res.data?.data?.list || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            meeting_place_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_place_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadType,
    };
  },
};
</script>
<style scoped></style>
